import { GenericError } from '@cian/peperrors/shared';

type TRedirectStatusCode = 301 | 302;

interface IRedirectErrorConfiguration {
  domain: string;
  message: string;
  location: string;
  statusCode?: TRedirectStatusCode;
}

export class RedirectError extends GenericError {
  public readonly location: string;
  public readonly statusCode: TRedirectStatusCode;

  public constructor({ location, statusCode, ...genericConfiguration }: IRedirectErrorConfiguration) {
    super({
      ...genericConfiguration,
      type: 'RedirectError',
    });

    this.location = location;
    this.statusCode = statusCode || 302;

    Object.setPrototypeOf(this, RedirectError.prototype);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, RedirectError);
    } else {
      this.stack = new Error().stack;
    }
  }
}
